import type { ReactNode } from 'react';

export interface StatCard {
  /** Value shown large. Strings so a formatted amount ("₱1,200.00") fits. */
  n: string | number;
  l: string;
  accent?: boolean;
}

export function StatCards({ cards }: { cards: readonly StatCard[] }): ReactNode {
  return (
    <div className="grid-cards">
      {cards.map((c) => (
        <div key={c.l} className={c.accent ? 'stat-card accent' : 'stat-card'}>
          <div className="n">{c.n}</div>
          <div className="l">{c.l}</div>
        </div>
      ))}
    </div>
  );
}
